import { CMS_FORM_SELECT_TRIGGER_CLASS } from "@/lib/cms/cms-theme.constants";
import { cn } from "@/lib/utils";

export const TOOLBAR_CONTROL_CLASS = "h-9 shrink-0";
export const TOOLBAR_ICON_CLASS = "h-[18px] w-[18px]";
export const TOOLBAR_SELECT_TRIGGER_CLASS = cn(
  "h-9 text-sm",
  CMS_FORM_SELECT_TRIGGER_CLASS,
);
